<template>
  <card shadow>
    <strong>
      {{ $t("select-category") }}
    </strong>
    <br />
    
    <base-dropdown v-if="categories">
      <base-button slot="title" type="secondary" class="dropdown-toggle">
        {{ categoryDropdownText }}
      </base-button>

      <div v-for="category in getCategories" :key="category.id || category.name">
        <a
          class="dropdown-item"
          @click="
            selectedCategory = category;
            selectedCase = null;
          "
          >{{ category.name }}</a
        >
      </div>
    </base-dropdown>

    <br/>

    <div v-if="selectedCategory">
      <strong>
        {{ $t("select-case") }}
      </strong>
      <br />

      <base-dropdown>
        <base-button slot="title" type="secondary" class="dropdown-toggle">
          {{ caseDropdownText }}
        </base-button>

        <div v-for="aCase in getCases" :key="aCase.id || aCase.case_number">
          <a class="dropdown-item" @click="setSelectedCase(aCase)">{{aCase.case_number}} {{
            aCase.title
          }}</a>
        </div>
      </base-dropdown>
    </div>
    <br/>
    <div v-if="selectedCase">
      <div v-if="showImageIcon">
        <small
          ><font-awesome-icon
            id="casePhoto"
            v-if="showImageIcon"
            style="cursor: pointer"
            icon="image"
          />&nbsp;{{ $t("image-info") }}<br/></small
        >
        <b-popover target="casePhoto" triggers="hover" placement="bottom">
          <img class="img-fluid" :src="getSelectedCase.photo" />
        </b-popover>
        <br/>
      </div>

      <span v-html="getSelectedCase.description"></span><br />
      <br />
      <strong><span v-html="getSelectedCase.case_question"></span></strong>
      <br />
      <br />
      <div v-if="getSelectedCase.description_above_cases">
        <small class="font-weight-bold">
          {{ getSelectedCase.description_above_cases }}
        </small>
      </div>
      <div v-for="choice in getCaseChoices" :key="choice.id || choice.order_number">
        {{ choice.order_number }}. {{ choice.choice_text }}<br />
      </div>
      <div v-if="getSelectedCase.description_below_cases">
        <small class="font-weight-bold">
          {{ getSelectedCase.description_below_cases }}
        </small>
      </div>
      <br/>
      <div v-if="getSelectedCase.facilitator_instructions">
        <span v-html="getSelectedCase.facilitator_instructions"></span>
        <br/>
        <br/>
      </div>      
      <base-button type="primary" @click="useAndCloseDialog()">{{
        $t("add")
      }}</base-button>
    </div>
    <br/>
    <base-button type="secondary" @click="closeDialog()">{{
      $t("cancel")
    }}</base-button>
  </card>
</template>

<script>
import {
  getRPSTemplateCategories,
  getRPSTemplateCases,
  getRPSTemplateCaseChoices,
  getRPSScenariosTemplates,
  getRPSCasesTemplates,
  getRPSCaseChoicesTemplates,
} from "@/services/APIService";

const sortby = require("lodash.sortby");

export default {
  props: ["locale"],
  data() {
    return {
      // templates:
      categories: [],
      cases: null,
      caseChoices: null,
      // scenarios usable as templates:
      scenarios: [],
      scenariosCases: null,
      scenariosCaseChoices: null,
      selectedCategory: null,
      selectedCase: null,
    };
  },
  mounted() {
    this.$bus.$on("close", () => {
      this.$bus.$emit("close-template-dialog");
    });
  },
  beforeDestroy() {
    this.$bus.$off("close");
  },
  async created() {
    this.categories = (await getRPSTemplateCategories()).data;
    this.cases = (await getRPSTemplateCases()).data;
    this.caseChoices = (await getRPSTemplateCaseChoices()).data;
    this.scenarios = (await getRPSScenariosTemplates()).data;
    this.scenariosCases = (await getRPSCasesTemplates()).data;
    this.scenariosCaseChoices = (await getRPSCaseChoicesTemplates()).data;
  },
  computed: {
    showImageIcon() {
      if (this.getSelectedCase && this.getSelectedCase.photo) {
        return true;
      } else {
        return false;
      }
    },
    getCategories() {
      const scenarios = this.scenarios.filter((scenario) => scenario.locale === this.locale);

      const combined = [];

      for (let i = 0; i < scenarios.length; i++) {
        combined.push({ name: scenarios[i].short_description, id: scenarios[i].rps_scenario_id, type: "rps_scenario" });
      }

      const categories = this.categories.filter(
        (category) => category.locale === this.locale
      );

      for (let i = 0; i < categories.length; i++) {
        combined.push({ name: categories[i].name, id: categories[i].id, type: "template" });
      }

      return sortby(combined, [
        (o) => {
          return o.name.toLowerCase();
        },
      ]);      
    },
    getSelectedCase() {
      return this.getCaseById(this.selectedCase);
    },
    getCases() {
      // Let's first find out type of the category
      if (this.selectedCategory.type === "template") {
        return this.cases.filter(
          (c) => c.rps_template_category === this.selectedCategory.id
        );
      } else {
        return this.scenariosCases.filter(
          (c) => c.rps_scenario === this.selectedCategory.id && c.locale === this.locale
        );
      }
    },
    getCaseChoices() {
      let filteredChoices = [];

      if (this.selectedCategory.type === "template") {
        filteredChoices = this.caseChoices.filter(
          (c) => c.rps_template_case === this.selectedCase
        );
      } else {
        filteredChoices = this.scenariosCaseChoices.filter(
          (c) => c.rps_case === this.selectedCase && c.locale === this.locale
        );
      }

      return sortby(filteredChoices, [
        (o) => {
          return o.order_number;
        },
      ]);
    },
    categoryDropdownText() {
      if (this.selectedCategory) {
        return this.selectedCategory.name;
      } else {
        return this.$t("category");
      }
    },
    caseDropdownText() {
      if (this.selectedCase) {
        return this.getCaseById(this.selectedCase).title;
      } else {
        return this.$t("case");
      }
    },
  },
  methods: {
    getCategoryById(id) {
      return this.categories.find((category) => category.id === id);
    },
    getCaseById(id) {
      if (this.selectedCategory.type === "template") {
        return this.cases.find((c) => c.id === id);
      } else {
        return this.scenariosCases.find((c) => c.rps_case === id && c.locale === this.locale)
      }
    },
    useAndCloseDialog() {
      this.$bus.$emit("add-case-from-template", this.selectedCase, this.selectedCategory.type);
      this.$bus.$emit("close-template-dialog");
    },
    closeDialog() {
      this.$bus.$emit("close-template-dialog");
    },
    setSelectedCase(aCase) {
      if (this.selectedCategory.type === "template") {
        this.selectedCase = aCase.id
      } else {
        this.selectedCase = aCase.rps_case
      }
    }
  },
};
</script>

<i18n>
{
  "fi": {
    "select-category": "Valitse aihealue",
    "select-case": "Valitse tilanne",
    "case": "Tilanne",
    "add": "Lisää valittu tilanne simulaatioon",
    "cancel": "Peru",
    "category": "Aihealue",
    "image-info": "Tässä tilanteessa on kuva, joka lisätään simulaatioon kyseiseen tilanteeseen. Voit vaihtaa kuvan halutessasi kuvaeditorissa."
  },
  "en": {
    "select-category": "Select category",
    "select-case": "Select case",
    "case": "Case",
    "add": "Add this case to simulation",
    "cancel": "Cancel",
    "category": "Category",
    "image-info": "In this case, there is a photo that is added to the simulation for the new case. You can change the photo in the photo editor if you wish."
  }
}
</i18n>
